import { Route } from "react-router-dom";
import { ROUTES, toStandalonePath } from "./manifest";

/**
 * FarmersPulseRoutes
 *
 * Renders every route declared in `manifest.js`.
 *
 * Props:
 *   standalone?: boolean — if true, mount routes at their standalone
 *     (root-URL) paths for farmerspulse.com; otherwise mount at the
 *     embedded `/farmers/*` paths used inside NaturePulse.
 *
 * Use inside a <Routes> block:
 *
 *   <Routes>
 *     ...other app routes...
 *     {FarmersPulseRoutes()}
 *   </Routes>
 *
 * or, in a fork, as the sole set of routes:
 *
 *   <Routes>
 *     {FarmersPulseRoutes({ standalone: true })}
 *   </Routes>
 */
export default function FarmersPulseRoutes({ standalone = false } = {}) {
  return ROUTES.map((r) => (
    <Route
      key={r.name}
      path={standalone ? toStandalonePath(r.path, r.standalonePath) : r.path}
      element={r.element}
    />
  ));
}
